/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import {Switch, Control, Group, TextField} from '@insticator/insticator-ui'; // iui-material
import SectionDescription from '../../../../../../material/expandablesection/sectiondescription/sectiondescription';
import SectionCard from '../../../../../../material/expandablesection/sectioncard/sectioncard';
import SectionGroup from '../../../../../../material/expandablesection/sectiongroup/sectiongroup';
import SectionGroupDescription
  from '../../../../../../material/expandablesection/sectiongroupdescription/sectiongroupdescription';
// styles
import injectSheet from 'react-jss';
import styles from './general_styles';
import {TIME_RANGE_LIST, DEFAULT_TITLE} from "../../../../../../state/slices/engagement";

export const FEEDBACK_MAX_LENGTH = 50;

/* ========== ~~~~~~~~~~ GENERAL CONFIGS - SENTIMENT ~~~~~~~~~~ ========== */
const GeneralConfigs = injectSheet(styles)((props) => {
  const {
    handleChangeFeedback,
    handleChangeOverview,
    handleChangeTimeRange,
    config
  } = props;

  return (
    <SectionCard klass={props.classes.generalconfig}>
      <SectionGroup>
        <SectionGroupDescription
          title='Text for Article Sentiment feedback question'
          description='(50 characters max)'
          titleClassName={'inline'}
          descriptionClassName={'inline'}
        />
        <br/>
        <TextField 
          name={'feedback'}
          type={'text'}
          value={config.title}
          handleChange={handleChangeFeedback}
          placeholder={DEFAULT_TITLE}
          maxlength={FEEDBACK_MAX_LENGTH}
        />

        {/* <div className="formelement">
          <input
            maxLength={FEEDBACK_MAX_LENGTH}
            className="textfield"
            type="text" name="feedback"
            value={config.title}
            onChange={handleChangeFeedback}
            placeholder={DEFAULT_TITLE}
          />
        </div> */}
      </SectionGroup>
      <SectionGroup row>
        <SectionGroupDescription
          title={'Show Summary of All Articles'}
          description={''}
        />
        <Switch
          variant={'primary'}
          on={config.enableOverview === true}
          handleClick={() => handleChangeOverview(!config.enableOverview)}/>
      </SectionGroup>
      <SectionGroup>
        <SectionGroupDescription
          title='Time range of Article Reactions'
          description="Select the overview timeframe of all the site's article reactions"
        />
        <Group name={'controls advance'}>
          {TIME_RANGE_LIST.map(i => <Control
            key={i.value}
            text={i.title}
            value={i.value}
            selected={i.value === config.overviewTimeRange}
            handleSelect={handleChangeTimeRange}
            variant={'secondary'}
            addCheckWhenSelected={true}
          />)}
        </Group>
      </SectionGroup>
    </SectionCard>
  );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default GeneralConfigs;

